'use client'

import { useCallback } from 'react'

import { useBootstrap } from '@/shared/lib/bootstrap'

export function BootstrapErrorFallback() {
  const { refetch, isFetching } = useBootstrap()

  const handleRetry = useCallback(() => {
    refetch()
  }, [refetch])

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-4 p-6"
      role="alert"
    >
      <h1 className="text-lg font-semibold text-foreground">
        Não foi possível carregar os dados
      </h1>
      <p className="max-w-md text-center text-sm text-muted-foreground">
        Verifique sua conexão e tente novamente. Se o problema continuar, entre
        em contato com o suporte.
      </p>
      <button
        type="button"
        onClick={handleRetry}
        disabled={isFetching}
        className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 disabled:opacity-50"
      >
        {isFetching ? 'Carregando…' : 'Tentar novamente'}
      </button>
    </div>
  )
}
